import { render, staticRenderFns } from "./HeaderContainer.vue?vue&type=template&id=4517bc46&scoped=true"
import script from "./HeaderContainer.vue?vue&type=script&lang=js"
export * from "./HeaderContainer.vue?vue&type=script&lang=js"
import style0 from "./HeaderContainer.vue?vue&type=style&index=0&id=4517bc46&prod&lang=scss"
import style1 from "./HeaderContainer.vue?vue&type=style&index=1&id=4517bc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4517bc46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,VCurrency: require('/var/www/tubber-new/components/global/v/currency.vue').default})
